import React, { useContext } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { Paper, Grid, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { makeStyles } from '@mui/styles';
import { ImageSearchContext } from '../../components/ImageSearchQueryContext';

const useStyles = makeStyles(() => ({
    header: {
        '& .MuiDataGrid-columnHeader': {
            background: '#E6D6D180 !important'
        },
        '& .MuiDataGrid-columnSeparator.MuiDataGrid-columnSeparator--sideRight': {
            display: 'none',
        },
        '& .MuiDataGrid-filler': {
            display: 'none',
        }
    }
}));


const ImageSearchResult = ({ searchQueryResponse, fetchDailyDetails }) => {
    const { setSearchQueryContext, searchQueryContext } = useContext(ImageSearchContext);
    const classes = useStyles();
    const columns = [
        {
            field: 'accountNumber', headerName: 'Account Number', width: 200,
            renderCell: (params) => (<div style={{ cursor: 'pointer', color: '#1976d2', fontWeight: 500 }}
                onClick={() => handleRowClick(params.row)}>{params.row.accountNumber}</div>)
        },
        { field: 'processedDate', headerName: 'Date', width: 200, renderCell: (params) => (<div>{new Date(params.row.processedDate).toLocaleDateString('en-US')}</div>) },
        { field: 'totalItems', headerName: 'Items', width: 150, },
        {
            field: 'lockboxSite',
            headerName: 'Lockbox Site',
            width: 181,
        },
        {
            field: 'lockboxNumber',
            headerName: 'Lockbox Number',
            width: 181,
        },
        {
            field: 'currency',
            headerName: 'Currency',
            width: 140,
        },
        {
            field: 'actions',
            headerName: '',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            renderCell: () => <MoreVertIcon fontSize='small' />,
        },
    ];
    const paginationModel = { page: 0, pageSize: 2 };

    const handleRowClick = (row) => {
        setSearchQueryContext({ ...searchQueryContext, accountNumber: row?.accountNumber })
        fetchDailyDetails()
    }


    return searchQueryResponse?.records ? <Grid container sx={{ padding: '24px' }}>
        <Paper sx={{ width: '100%' }}>
            <Grid item sx={{ background: '#FAFAFA' }}>
                <Typography sx={{ padding: '12px 16px', fontSize: '16px', color: '#4C4C4C' }}>
                    Lockbox Activity and Image Summary
                </Typography>
            </Grid>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <DataGrid
                    rows={searchQueryResponse?.records || []}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[2,4,6,8, 10]}
                    //checkboxSelection
                    getRowId={(row => row.accountNumber)}
                    sx={{ border: 0 }}
                    disableColumnFilter
                    disableColumnSorting
                    disableAutosize
                    disableColumnMenu
                    disableColumnResize
                    disableColumnSelector
                    classes={{ root: classes.header }}

                />
            </div>

        </Paper>
    </Grid> : null
}

export default ImageSearchResult;